module.exports = __webpack_public_path__ + "NotoSansKR-Regular-Hestia.47656.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/fonts/woff/NotoSansKR-Regular-Hestia.woff
// module id = ./src/_asset/sources/assets/fonts/woff/NotoSansKR-Regular-Hestia.woff
// module chunks = main